import { diagnostics } from '@blend/ui-common';
import { RedirectFunction, RouterState } from 'react-router';
import { setLoanType } from 'login-utils/onboardingForm';
import * as specialtyVehicleForm from 'login-utils/specialtyVehicleForm';
import * as queryString from 'query-string';
import store from 'login-store';
import States from 'login-constants/states';
import { storeInitialLoanType } from './onboardingRoutingUtils';
import { goBackIfLoanTypeNotEnabled } from './routingUtils';
import * as sessionUtils from './sessionUtils';

const goBackIfSpecialtyVehicleDisabled = goBackIfLoanTypeNotEnabled('SPECIALTY_VEHICLE');

// for specialty vehicle related routes, there is no complex onEnter logic (unlike mortgage
// onboarding), because the user can easily go back and forth between states.
// but we should still check for the SPECIALTY_VEHICLE loanType and save query params
export function specialtyVehicleCategoryOnEnter(nextState: RouterState) {
  goBackIfSpecialtyVehicleDisabled(nextState);

  const query = queryString.parse(nextState.location.search);
  sessionUtils.saveQueryToSession(query);
  storeInitialLoanType(query);
  setLoanType('SPECIALTY_VEHICLE');
}

export function specialtyVehicleLoanPurposeOnEnter(nextState: RouterState, replace: RedirectFunction) {
  goBackIfSpecialtyVehicleDisabled(nextState);

  const query = queryString.parse(nextState.location.search);
  sessionUtils.saveQueryToSession(query);

  const reduxState = store.getState() as ReduxState;
  const specialtyVehicleCategory = specialtyVehicleForm.getSpecialtyVehicleCategory(reduxState);

  if (!specialtyVehicleCategory) {
    const nextURL = nextState.location.pathname;
    diagnostics.breadcrumb(
      `Redirecting from ${nextURL} to /${States.SPECIALTY_VEHICLE_CATEGORY} because no vehicle category is chosen`,
    );
    return replace({
      pathname: `/${States.SPECIALTY_VEHICLE_CATEGORY}`,
      query,
    });
  }
}
